import 'leaflet/dist/leaflet.css';
import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import router from './router'
import VueI18n from 'vue-i18n';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(VueI18n);
function loadLocaleMessages() {
  const locales = require.context(
    '../public/locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const browserLang = (navigator.language || navigator.userLanguage || 'fr').split('-')[0]
const savedLang = localStorage.getItem('lang')
const selectedLang = savedLang || browserLang

const i18n = new VueI18n({
  locale: selectedLang, // set locale
  fallbackLocale: 'fr', // fallback if locale not found
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
});
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

new Vue({
  store,router,
  i18n,
  render: h => h(App),
}).$mount('#app')
